<app-modal-header [modalTitle]="modalTitle" [showCloseBtn]="false" (closeModal)="close()"></app-modal-header>
<!-- Modal Content -->
<div class="modal-content" [attr.loading]="loading" [attr.flexDirection]="'row'" [attr.size]="'large'">
    <!-- Main section -->
    <section *ngIf="!loading" id="store-index-output-tabs-container" class="primary-section-container w-100">
        <mat-tab-group
            #changeEvent
            id="output-modal-tab-group"
            color="accent"
            mat-stretch-tabs="false"
            mat-align-tabs="start"
            [selectedIndex]="activeTab"
            (selectedIndexChange)="tabChanged($event)"
            preserveContent="true"
        >
            <!-- Store Index Table data Tab -->
            <mat-tab label="Table">
                <ng-template matTabContent>
                    <div id="output-grid-container">
                        <span class="output-grid-button-wrapper">
                            <button
                                mat-raised-button
                                color="accent"
                                (click)="onRebalanceRows($event)"
                                [disabled]="
                                    loading ||
                                    (!isRebalancedEnabled &&
                                        gridApi?.getGridOption('context')?.percentageTotal >= 99.98 &&
                                        gridApi?.getGridOption('context')?.percentageTotal <= 100.02) ||
                                    (!isRebalancedEnabled && gridApi?.getGridOption('context')?.percentageTotal === 0)
                                "
                            >
                                Rebalance
                            </button>
                        </span>

                        <ag-grid-angular
                            id="store-index-output-grid"
                            [columnDefs]="columnDefs"
                            class="ag-theme-alpine ag-grid-container"
                            [gridOptions]="gridOptions"
                        ></ag-grid-angular>
                    </div>
                </ng-template>
            </mat-tab>
            <!-- Store Index Charts data Tab -->
            <mat-tab label="Charts" [disabled]="loading">
                <ng-template matTabContent>
                    <div id="main-chart-wrapper">
                        <!-- Doughnut Chart Section -->
                        <section id="doughnut-section">
                            <form>
                                <mat-form-field style="width: 100%">
                                    <mat-select
                                        placeholder="{{ productAttributesToDisplay[0] }}"
                                        [(ngModel)]="selectedProductAttr"
                                        name="productAttr"
                                        (selectionChange)="onProductAttrSelectionChange($event)"
                                    >
                                        <mat-option
                                            *ngFor="let productAttr of productAttributesToDisplay"
                                            [value]="productAttr"
                                        >
                                            {{ productAttr }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <app-basic-headers
                                    [sectionName]="'Location Attribute Split'"
                                    color="lte"
                                ></app-basic-headers>
                                <mat-form-field style="width: 100%">
                                    <mat-select
                                        placeholder="{{ familyAttributes[0] }}"
                                        [(ngModel)]="selectedFamilyAttr"
                                        name="attr"
                                        (selectionChange)="onSelectionChange($event)"
                                        [disabled]="!selectedProductAttr"
                                    >
                                        <mat-option *ngFor="let attr of familyAttributes" [value]="attr">
                                            {{ attr }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </form>
                            <div *ngFor="let attr of familyAttributes">
                                <div class="section-body-container chartWrapper custom-vertical-scroll">
                                    <p-chart
                                        *ngIf="selectedProductAttr && selectedFamilyAttr && selectedFamilyAttr === attr"
                                        class="chart"
                                        id="store-index-output-doughnut-chart"
                                        type="doughnut"
                                        [data]="doughnutChartConfig[selectedProductAttr][attr]"
                                        [options]="doughnutChartOptions[selectedProductAttr][attr]"
                                    >
                                    </p-chart>
                                </div>
                            </div>
                        </section>
                        <!-- Bar Chart Section -->
                        <section id="bar-chart-section">
                            <app-basic-headers
                                [sectionName]="'Store Split - Original vs Current'"
                                color="lte"
                            ></app-basic-headers>

                            <!-- Legend Container -->
                            <div id="bar-chart-custom-legend-container">
                                <div
                                    id="original-values-btn-wrapper"
                                    class="legend-container"
                                    (click)="onClickLegend(0)"
                                >
                                    <div class="legend-color-block" [attr.label]="'original'"></div>
                                    <p>Original Values</p>
                                </div>
                                <div
                                    id="current-changes-btn-wrapper"
                                    class="legend-container"
                                    (click)="onClickLegend(1)"
                                >
                                    <div class="legend-color-block" [attr.label]="'current'"></div>
                                    <p>Current Values</p>
                                </div>
                            </div>
                            <div class="section-body-container chartWrapper custom-vertical-scroll">
                                <p-chart
                                    id="mainBarChart"
                                    #mainBarChartView
                                    class="chart"
                                    type="bar"
                                    model="chartView.horizontalBarModel"
                                    [data]="barChartConfig"
                                    [options]="barChartOptions"
                                    [width]="parentWidth"
                                >
                                </p-chart>
                            </div>
                        </section>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </section>
    <!-- Loading Component -->
    <app-loader *ngIf="loading" [loadingMessage]="loadingMessage"></app-loader>
</div>

<app-modal-footer
    (closeModal)="close()"
    [showUpdateBtn]="true"
    [closeBtnText]="'Close'"
    (update)="onSaveOutputChanges($event)"
    confirmBtnText="Save"
    [loading]="isSaving"
    [disabled]="
        loading ||
        isSaving ||
        activeTab === 1 ||
        isRebalancedEnabled ||
        gridApi?.getGridOption('context')?.percentageTotal <= 99.98 ||
        gridApi?.getGridOption('context')?.percentageTotal >= 100.02 ||
        !rebalanceExecuted
    "
>
</app-modal-footer>
